import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useEditApplication = () => {
  const { enqueueSnackbar } = useSnackbar();

  const editRequest = (
    payload,
    getApplicationList,
    setIsEditModalOpen,
    setEditLoading,
  ) => {
    axiosClient
      .put(`SettingSystem/Application/Update`, payload)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          getApplicationList();
          setIsEditModalOpen(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setEditLoading(false));
  };
  return [editRequest];
};

export default useEditApplication;
